/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes/'
export default StyleSheet.create({

  content: {
    flex: 1,

    minHeight: 44,
    backgroundColor: '#FFFFFF',


  },
  leftText: {
    color : Fonts.style.color.baseColor



  },

  shadow: {
    // shadowColor: '#000',
    // shadowOffset: { width: 0, height: 2 },
    // shadowOpacity: 0.9,
    // shadowRadius: 2,
    // elevation: 1,
  },
  title: {
    fontSize: 14,
    fontFamily: Fonts.style.font.bold,
    color: Fonts.style.color.baseColor
  },
  subTitle: {
    fontFamily: Fonts.style.font.regular,
    color: `black`,
    fontSize: 12,

  },
  rightTitle: {
    fontFamily: Fonts.style.font.light,
    color: Fonts.style.color.baseColor
  },
  container: {

    flexDirection: 'row',
    minHeight: 60,
    backgroundColor: '#FFFFFF',

  },
  bottomBorder: {

    borderBottomWidth: 0.5,
    borderColor: 'grey'
  },
  left: {
    width: '50%',
    flexDirection: 'row',
    paddingLeft: 10,

    alignItems: 'center',

  },

  right: {
    width: '50%',
    flexDirection: 'row',
    minHeight: 44,
    justifyContent: 'flex-end',



    alignItems: 'center'
  },
  img: {
    width: 40,
    height: 40,

  },

  avatar: {
    width: 35,
    height: 35,
    borderRadius: 17,
    marginRight: 17
  },

  buttonText: {
    fontFamily: Fonts.style.font.bold,
    color: '#FFFFFF',
    fontSize: 14
  },
  styleInnerButton :{
    width: 100,
    height: 30,
  },
  button: {
    width: 100,
    height: 30,
    borderRadius: 5,
    marginRight: 5,
    borderColor: Fonts.style.color.baseColor,
    borderWidth: 1
  },
})
